import { createSlice } from '@reduxjs/toolkit';

const directiosApiRoutePointSlice = createSlice({
  name: 'directiosApiRoutePoint',
  initialState: {
    profile: 'driving',
    points: [],
    geometry: null,
    distanceMeters: 0,
    durationSeconds: 0
  },
  reducers: {
    setDirectiosApiRoutePoint(state, action) {
      const payload = action.payload || {};
      state.profile = payload.profile || 'driving';
      state.points = Array.isArray(payload.points) ? payload.points : [];
      state.geometry = payload.geometry || null;
      state.distanceMeters = Number(payload.distanceMeters || 0);
      state.durationSeconds = Number(payload.durationSeconds || 0);
    },
    resetDirectiosApiRoutePoint(state) {
      state.profile = 'driving';
      state.points = [];
      state.geometry = null;
      state.distanceMeters = 0;
      state.durationSeconds = 0;
    }
  }
});

export const { setDirectiosApiRoutePoint, resetDirectiosApiRoutePoint } = directiosApiRoutePointSlice.actions;
export default directiosApiRoutePointSlice.reducer;
